import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDepartmentEdit } from '@/module/Department/model/DepartmentQuery';
import {
  DepartmentSchema,
  defaultDepartmentValues,
  departmentSchema,
} from '@/module/Department/model/DepartmentSchema';

import { useAppNotification } from '@feature/utils';

import { DepartmentForm } from './DepartmentForm';
import { Department } from './model/DepartmentTypes';

interface DepartmentEditProps {
  department: Department;
}

const convert = (department: Department): DepartmentSchema => ({
  ...department,
});

export function DepartmentEdit(props: DepartmentEditProps) {
  const { department } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDepartmentEdit(department.id);

  const notification = useAppNotification();
  const onSubmit = (values: DepartmentSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(department), [department]);
  const navigate = useNavigate();

  return (
    <DepartmentForm
      title={t('departments.form.title.edit')}
      schema={departmentSchema}
      defaultValues={defaultDepartmentValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
